<template>
  <div class="bg-gray">
    <div class="form-content">
      <el-form
          v-model="formData"
          :rules="{}"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="赛区" prop="name">{{ formData.saiqu_name }}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="单位" prop="name">{{ formData.danwei }}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="队伍名称" prop="name">{{ formData.danwei + formData.mingcheng + '啦啦队' }}</el-form-item>
          </el-col>
        </el-row>

        <el-divider>优秀教练员申报</el-divider>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="优秀教练员">
              <div style="cursor: pointer" @click="showJiaolianPicker = true">请选择教练员 <i class="el-icon-arrow-right"></i>
              </div>
              <div v-show="formData.jiaolian.length>0">
                <div class="memberLi" v-for="(jiaolian ,index) in formData.jiaolian" :key=index>
                  <!--                  第{{(['一','二','三','四','五'])[index]}}教练员-->
                  <el-tag
                      :key="index"
                      round
                      closable
                      type="primary"
                      @close="formData.jiaolian.splice(index,1)"
                  > {{ jiaolian.name }} {{ jiaolian.num }}
                  </el-tag>
                </div>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col class="footer-button">
            <el-button type="primary" @click="submitForm('ruleForm')" :loading="saveLoading">立即申报
            </el-button>
            <!--            <el-button @click="resetForm('ruleForm')" plain>重置</el-button>-->
          </el-col>
        </el-row>
      </el-form>

      <SubjectCaipanPicker
          :show="showCaipanPicker"
          :limit="5"
          @onChange="onCaipanChange"
          @onClose="showCaipanPicker=false"
          :options="formData.caipan_options"
          :defaultValue="formData.caipan"
          @onConfirm="onCaipanConfirm"
      ></SubjectCaipanPicker>

      <SubjectJiaolianPicker
          :show="showJiaolianPicker"
          :limit="5"
          @onChange="onJiaolianChange"
          @onClose="showJiaolianPicker=false"
          :options="formData.jiaolian_options"
          :defaultValue="formData.jiaolian"
          @onConfirm="onJiaolianConfirm"
      ></SubjectJiaolianPicker>


      <LoginDialog :show="loginShow" @loginSuccess="loginSuccess" @loginCancel="loginCancel"/>
    </div>
  </div>
</template>
<style scoped>
.box {
  /*margin-bottom: 1.5rem;*/
}

.memberResultWrap {
  background: #F3F3F3;
  margin: 0.2rem;
  border-radius: 8px;
  padding: 0.2rem;
}

.memberResultWrap .memberLi {
  font-size: 14px;
  color: #666;
  height: 36px;
  line-height: 36px;
}

.memberResultWrap .memberLi .van-tag {
  width: auto !important;
}

.savebtn {
  position: fixed;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}


.van-tag {
  width: 55px;
  margin-left: 10px;
  text-align: center;
}

.between {
  justify-content: space-between;
}


</style>
<script>
import Vue from 'vue';
import area from "../../../utils/area";
import validator from "../../../utils/validator";
import PicUploader from '@/components/picker/PicUploader.vue';

import {
  Cell,
  Field,
  Area,
  Form,
  Divider,
  CellGroup,
  RadioGroup,
  Radio,
  Icon,
  Dialog,
  Toast,
  Popup,
  Picker,
  Sidebar,
  SidebarItem,
  Tag,
  Stepper,
  Switch,
  Button
} from 'vant';
import CaipanPicker from '@/components/picker/CaipanPicker.vue';
import JiaolianPicker from '@/components/picker/JiaolianPicker.vue';
import LoginDialog from '@/components/LoginDialog.vue';

import SubjectJiaolianPicker from '@/components/picker/SubjectJiaolianPicker.vue';
import SubjectCaipanPicker from '@/components/picker/SubjectCaipanPicker.vue';

Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Area).use(RadioGroup).use(Dialog).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
    .use(Switch).use(Button);
export default {
  name: 'SaiApplyFormStep1',
  components: {
    [Field.name]: Field,
    PicUploader,
    CaipanPicker,
    JiaolianPicker,
    SubjectJiaolianPicker,
    SubjectCaipanPicker,
    LoginDialog
  },
  data: function () {
    return {
      validator,
      loginShow: false,
      saveLoading: false,
      saiqu_id: this.$route.query.saiqu_id,
      showCaipanPicker: false,
      showJiaolianPicker: false,
      showNumTypePicker: false,
      numTypeColumns: ['身份证', '护照', '其他'],
      showArea: false,
      areaList: {},
      areaValue: '',
      submitType: '',
      formData: {
        id: 0,
        saiqu_name: '',
        numTypeName: '身份证',
        danwei: '',
        ldcardtype: 1,
        ldsex: 1,
        heying: [],
        caipan: [],
        jiaolian: [],
        jiaolian_options: [],
        caipan_options: [],
      },
    }
  },
  filters: {},
  mounted() {
    let that = this;
    that.areaList = area;
    that.formData.id = this.$route.query.id;
    document.title = '秩序册填写';
    this.fetch();
  },
  watch: {
    formData() {
    }
  },
  destroyed() {
  },
  methods: {
    fetch() {
      let that = this;
      that.$api.get('/api/isai/JiaolianCaipanStepDetail', {
        saiqu_id: that.saiqu_id,
        id: that.formData.id,
      }, (res) => {
        that.formData = res.data;
      }, (res) => {
        console.log('没有登录');
      })
    },
    onQuestion() {
      console.log('onQuestion')
    },
    onCaipanConfirm(values) {
      console.log('onCaipanConfirm', values)
      this.showCaipanPicker = false;
      this.formData.caipan = [...values];
    },
    onCaipanChange(values) {
      console.log('onCaipanChange', values)
      this.formData.caipan = [...values];
    },
    onJiaolianConfirm(values) {
      console.log('onJiaolianConfirm', values)
      this.showJiaolianPicker = false;
      this.formData.jiaolian = [...values];
    },
    onJiaolianChange(values) {
      console.log('onJiaolianChange', values)
      this.formData.jiaolian = [...values];
    },
    onNumTypeConfirm(value, index) {
      this.formData.numTypeName = value;
      this.formData.ldcardtype = index + 1;
      this.showNumTypePicker = false;
    },
    jumToOld(id) {
      rbLink({
        name: 'ISaiApplyList'
      }, 'replace')
    },

    submitForm(formName) {
      const that = this;
      // 拿到地区的 省市区名称
      // that.formData["area"] = that.formData.areas[2];

      console.log(that.formData, that.$refs[formName])
      for (let field in that.formData) {
        if (this.formData.jiaolian.length == 0) {
          this.$message.warning('请至少选择一位教练');
          return
        }
      }
      that.saveLoading = true;
      that.$api.post('/api/isai/jiaolianCaipanApply', {
        id: that.formData.id,
        caipan: that.formData.caipan,
        jiaolian: that.formData.jiaolian,
      }, (res) => {
        that.saveLoading = false;

        that.$message.success('保存成功');
        setTimeout(function () {
          rbLink({
            'name': 'ISaiApplyDetail',
            'query': {}
          })
        }, 50);
      }, (res) => {
        that.$message.error(res.msg);
        that.saveLoading = false;
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    onSubmit(values) {
      console.log('onSubmit-values', values);
      console.log('submitType', this.submitType);

      let that = this;
      console.log(that.formData)
      that.formValidate = true;
      for (let field in that.formData) {

        if (this.formData.jiaolian.length == 0) {
          Toast('请至少选择一位教练');
          return
        }
      }
      that.saveLoading = true;
      that.$api.post('/api/isai/jiaolianCaipanApply', {
        id: that.formData.id,
        caipan: that.formData.caipan,
        jiaolian: that.formData.jiaolian,
      }, (res) => {
        that.saveLoading = false;

        Toast('保存成功');
        setTimeout(function () {
          rbLink({
            'name': 'ISaiApplyDetail',
            'query': {}
          }, 'back')
        }, 50);
      }, (res) => {
        Toast.fail(res.msg);
        that.saveLoading = false;
      })
    },
    save(values) {
      this.submitType = 'save';
    },
    onFailed(errorInfo) {
      console.log('failed', errorInfo);
    },
    submit(values) {
      this.submitType = 'submit';
    },

    loginSuccess(res) {
      console.log('-------登录成功--------', res);
      this.loginShow = false;
      this.fetch();
    },

    loginCancel() {
      console.log('-------取消登录--------');
      // this.loginShow = false;
    },
  }
}
</script>



// WEBPACK FOOTER //
// SaiApplyFormJiaolianCaipan.vue?78949caa